var exports = {
  "n": "x31de4314--3cee4d--link",
};

module.exports = exports;
